module.exports = __webpack_public_path__ + "img/3.e1588704.png";